import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'

import {
    SearchEntitiesInput,
    SearchEntitiesOutput,
    GetEntityHistoryInput,
    GetEntityHistoryOutput,
    GetEntityProvisioningStateInput,
    GetEntityProvisioningStateOutput,
    ApplyEntityGraphInput,
    ApplyEntityGraphOutput,
} from '@amzn/coral_com-amazon-ihmclaire'
import { validateRequired } from './listenerUtils'

// ========================================
// READ OPERATIONS (ViewBringUp)
// ========================================

export async function searchEntitiesListener (message: any): Promise<SearchEntitiesOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.searchEntities(SearchEntitiesInput.clone(params)).toPromise()
}

export async function getEntityHistoryListener (message: any): Promise<GetEntityHistoryOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getEntityHistory(GetEntityHistoryInput.clone(params)).toPromise()
}

export async function getEntityProvisioningStateListener (message: any): Promise<GetEntityProvisioningStateOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getEntityProvisioningState(GetEntityProvisioningStateInput.clone(params)).toPromise()
}

// ========================================
// WRITE OPERATIONS (ManageBringUp)
// ========================================

export async function applyEntityGraphListener (message: any): Promise<ApplyEntityGraphOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    // Rehydrate with fromJson, NOT the shallow clone. postMessage transports the tool's request via
    // the structured-clone algorithm, which strips every prototype, so each entitiesToPut element
    // arrives here as a plain object. A Coral entity carries its polymorphic subtype only on its
    // constructor (Camera/MerchandisingFixture/etc. -> constructor.fullyQualifiedTypeName), and that
    // identity is lost crossing the frame. ApplyEntityGraphInput.clone() is shallow and would leave
    // the entities prototype-less, so the outbound Coral toJson() reads an undefined type and throws
    // CoralSerializationTypeError. fromJson() instead reads each entity's own __type (which the tool
    // stamps before send) and reconstructs the correct subtype instance, restoring the constructor so
    // re-serialization succeeds.
    return client.applyEntityGraph(ApplyEntityGraphInput.fromJson(params)).toPromise()
}
